module.exports = __webpack_public_path__ + "img/thumbnail_HighlandCattle_m_leucistic.98f7358c.png";